import { checkApiKeyManagementKeysResource } from '@atlassian/jira-router-resources-eoc-api-key-management/src/services/index.tsx';
import { useResource } from '@atlassian/react-resource-router';

export const useApiKeyManagementInfo = () => {
	const { loading, error, data } = useResource(checkApiKeyManagementKeysResource());
	return {
		hasKeys: data ?? false,
		loading,
		error,
	};
};
